import posthog from 'posthog-js';
import logger from '@/lib/logger';

let initialized = false;

export function initPostHog() {
  if (initialized) return;

  const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
  const host = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || 'https://us.i.posthog.com';
  const isProd = import.meta.env.MODE === 'production';

  // Production-only as requested
  if (!isProd) {
    return;
  }

  if (!key) {
    logger.warn('PostHog: VITE_POSTHOG_KEY missing; analytics not initialized');
    return;
  }

  posthog.init(key, {
    api_host: host,
    // Capture initial pageview automatically; SPA changes will be captured manually
    capture_pageview: true,
    autocapture: true,
    // Persist across tabs/sessions
    persistence: 'localStorage+cookie',
  });

  // Explicitly start session recording per your preference
  try {
    posthog.startSessionRecording();
  } catch {}

  initialized = true;
}

export function capturePageview(path?: string) {
  if (!initialized) return;
  const props = path ? { $current_url: path } : undefined;
  posthog.capture('$pageview', props);
}

export function identifyUser(distinctId: string, properties?: Record<string, any>) {
  if (!initialized) return;
  posthog.identify(distinctId, properties || {});
}

export function resetUser() {
  if (!initialized) return;
  posthog.reset();
}

export function trackEvent(event: string, properties?: Record<string, any>) {
  if (!initialized) return;
  try {
    posthog.capture(event, properties);
  } catch {}
}

export function setGroup(groupType: string, groupKey: string, properties?: Record<string, any>) {
  if (!initialized) return;
  try {
    posthog.group(groupType, groupKey, properties);
  } catch {}
}

export default posthog;